export default "__VITE_ASSET__7GtgNokV__"